import { useInactivityTracking } from './useInactivityTracking'

export default useInactivityTracking
